import { useState, useEffect } from "react";
import { puedeCrear } from "../auth/permisos";
import { avisarError } from "../../shared/errores";
import { eliminar, guardar, listar } from "../../services/datos";
import DateInput from "../../shared/components/DateInput";

import { avisar, confirmar } from "../../shared/avisos";
import Selector from "../../shared/components/Selector";
import Esqueleto from "../../shared/components/Esqueleto";

// Estado de la persona en la iglesia. Cuando un miembro empieza a servir, se le pone "Servidor".
export const ESTADOS = [
  { id: "visitante", label: "Visitante", ayuda: "Vino una o pocas veces", color: "border border-sky-500/30 bg-sky-500/15 text-sky-300" },
  { id: "congregante", label: "Congregante", ayuda: "Asiste con regularidad, aún no es miembro", color: "bg-sky-800 text-sky-200" },
  { id: "miembro", label: "Miembro", ayuda: "Completó el proceso de membresía", color: "border border-emerald-500/30 bg-emerald-500/15 text-emerald-300" },
  { id: "servidor", label: "Servidor", ayuda: "Miembro que sirve en la iglesia", color: "border border-amber-500/30 bg-amber-500/15 text-amber-300" },
  { id: "inactivo", label: "Inactivo", ayuda: "Dejó de asistir", color: "border border-zinc-500/30 bg-zinc-500/15 text-zinc-400" },
];
const ESTADO = Object.fromEntries(ESTADOS.map((e) => [e.id, e]));

const camposVacios = {
  nombres: "", apellidos: "", email: "", telefono: "",
  whatsapp: "", fecha_nacimiento: "", genero: "",
  estado_civil: "", estado: "visitante", fecha_ingreso: "",
  como_llego: "", notas: ""
};

function FormularioMiembro({ inicial, onGuardar, onCancelar }) {
  const [form, setForm] = useState(inicial || camposVacios);
  const [guardando, setGuardando] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!form.nombres || !form.apellidos || !String(form.email || "").trim() || !form.fecha_ingreso) {
      avisar("Nombres, apellidos, correo y fecha de ingreso son obligatorios");
      return;
    }
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(String(form.email).trim())) {
      avisar("Escribe un correo válido");
      return;
    }
    setGuardando(true);
    try {
      await onGuardar(form);
    } finally {
      setGuardando(false);
    }
  };

  const input = "campo";
  const label = "etiqueta";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-black/80 p-4 backdrop-blur-sm ventana-fondo">
      <div className="w-full max-w-2xl max-h-screen overflow-y-auto rounded-2xl border border-white/10 bg-zinc-950 p-6 sm:p-8 ventana-panel">
        
        <h3 className="text-xl font-black uppercase tracking-tight text-white mb-6">
          {inicial ? "Editar Miembro" : "Nuevo Miembro"}
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            
          <div>
            <label className={label}>Nombres *</label>
            <input name="nombres" value={form.nombres} onChange={handleChange} className={input} placeholder="Nombres" />
          </div>

          <div>
            <label className={label}>Apellidos *</label>
            <input name="apellidos" value={form.apellidos} onChange={handleChange} className={input} placeholder="Apellidos" />
          </div>

          <div>
            <label className={label}>Correo *</label>
            <input name="email" type="email" value={form.email || ""} onChange={handleChange} className={input} placeholder="correo@email.com" />
            <p className="mt-1 text-xs text-gray-500">Identifica a la persona: con él se registra y entra. No se repite.</p>
          </div>

          <div>
            <label className={label}>Teléfono</label>
            <input name="telefono" value={form.telefono} onChange={handleChange} className={input} placeholder="300 000 0000" />
          </div>

          <div>
            <label className={label}>WhatsApp</label>
            <input name="whatsapp" value={form.whatsapp} onChange={handleChange} className={input} placeholder="300 000 0000" />
          </div>

          <DateInput label="Fecha de Nacimiento" name="fecha_nacimiento" value={form.fecha_nacimiento} onChange={handleChange} className={input} />

          <div>
            <label className={label}>Género</label>
            <Selector name="genero" value={form.genero} onChange={handleChange} className={input}>
              <option value="">Seleccionar</option>
              <option value="masculino">Masculino</option>
              <option value="femenino">Femenino</option>
            </Selector>
          </div>

          <div>
            <label className={label}>Estado Civil</label>
            <Selector name="estado_civil" value={form.estado_civil} onChange={handleChange} className={input}>
              <option value="">Seleccionar</option>
              <option value="soltero">Soltero/a</option>
              <option value="casado">Casado/a</option>
              <option value="viudo">Viudo/a</option>
              <option value="divorciado">Divorciado/a</option>
            </Selector>
          </div>

          <div>
            <label htmlFor="miembro-estado" className={label}>Estado *</label>
            <Selector id="miembro-estado" name="estado" value={ESTADO[form.estado] ? form.estado : "miembro"} onChange={handleChange} className={input}>
              {ESTADOS.map((e) => (
                <option key={e.id} value={e.id}>{e.label}</option>
              ))}
            </Selector>
            <p className="text-gray-500 text-xs mt-1">{ESTADO[form.estado]?.ayuda || ESTADO.miembro.ayuda}</p>
          </div>

          <DateInput label="Fecha de Ingreso *" name="fecha_ingreso" value={form.fecha_ingreso} onChange={handleChange} className={input} />

          <div>
            <label className={label}>¿Cómo llegó?</label>
            <Selector name="como_llego" value={form.como_llego} onChange={handleChange} className={input}>
              <option value="">Seleccionar</option>
              <option value="invitado">Invitado por alguien</option>
              <option value="redes">Redes sociales</option>
              <option value="busqueda">Búsqueda en internet</option>
              <option value="paso">Pasó por el lugar</option>
              <option value="otro">Otro</option>
            </Selector>
          </div>

          <DateInput label="Fecha de Bautismo" name="fecha_bautismo" value={form.fecha_bautismo || ""} onChange={handleChange} className={input} />

        </div>

        <div className="mt-4">
          <label className={label}>Notas</label>
          <textarea name="notas" value={form.notas} onChange={handleChange} className={input} rows={3} placeholder="Notas adicionales..." />
        </div>

        <div className="flex gap-3 mt-6">
          <button onClick={handleSubmit} disabled={guardando} className="flex-1 btn-primario">
            {guardando ? "Guardando..." : "Guardar"}
          </button>
          <button onClick={onCancelar} className="flex-1 btn-fantasma">
            Cancelar
          </button>
        </div>

      </div>
    </div>
  );
}

function Miembros({ usuario }) {
  const [miembros, setMiembros] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [busqueda, setBusqueda] = useState("");
  const [mostrarForm, setMostrarForm] = useState(false);
  const [miembroEditar, setMiembroEditar] = useState(null);
  const [filtroEstado, setFiltroEstado] = useState("todos");

  const cargarMiembros = () => {
    setCargando(true);
    listar("miembros", { orden: "apellidos" })
      .then((data) => { setMiembros(data); setCargando(false); })
      .catch((e) => { setCargando(false); avisarError(e); });
  };

  useEffect(() => { cargarMiembros(); }, []);

  const guardarMiembro = async (form) => {
    try {
      await guardar("miembros", miembroEditar?.id, form);
      setMostrarForm(false);
      setMiembroEditar(null);
      cargarMiembros();
    } catch (e) {
      avisar(e.message || "No se pudo guardar el miembro", "error");
    }
  };

  const eliminarMiembro = async (id, nombre) => {
    if ((await confirmar(`¿Eliminar a ${nombre}?`, { aceptar: "Eliminar" }))) {
      eliminar("miembros", id)
        .then(() => cargarMiembros())
        .catch((e) => avisar(e.message, "error"));
    }
  };

  const miembrosFiltrados = miembros.filter((m) => {
    const coincideBusqueda = 
        `${m.nombres} ${m.apellidos}`.toLowerCase().includes(busqueda.toLowerCase()) ||
        (m.email || "").toLowerCase().includes(busqueda.toLowerCase());
    const coincideEstado = filtroEstado === "todos" || m.estado === filtroEstado;
    return coincideBusqueda && coincideEstado;
  });

  const servidores = miembros.filter((m) => m.estado === "servidor").length;

  return (
    <div className="p-6">

      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="titulo-pagina">Miembros</h2>
          <p className="text-gray-400 text-sm mt-1">{miembros.length} personas registradas · {servidores} servidores</p>
        </div>
        {puedeCrear(usuario) ? (
          <button
            onClick={() => { setMiembroEditar(null); setMostrarForm(true); }}
            className="btn-primario"
          >
            Nuevo Miembro
          </button>
        ) : (
          <span className="text-sm text-gray-400">Solo pastor o administrador puede crear</span>
        )}
      </div>

      <div className="flex gap-4 mb-6 flex-wrap">
        <input
          type="text"
          placeholder="Buscar por nombre o correo..."
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
          className="flex-1 min-w-48 campo"
        />
        <Selector
          value={filtroEstado}
          onChange={(e) => setFiltroEstado(e.target.value)}
          className="campo w-auto"
        >
          <option value="todos">Todos</option>
          <option value="visitante">Visitantes</option>
          <option value="congregante">Congregantes</option>
          <option value="miembro">Miembros</option>
          <option value="servidor">Servidores</option>
          <option value="inactivo">Inactivos</option>
        </Selector>
      </div>

      {cargando ? (
        <Esqueleto tipo="tarjetas" texto="Cargando miembros…" />
      ) : miembrosFiltrados.length === 0 ? (
        <div className="text-center py-20">
          <p className="text-gray-400 text-lg">No hay miembros registrados aún</p>
          <p className="text-gray-600 text-sm mt-2">Haz clic en "Nuevo Miembro" para agregar el primero</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {miembrosFiltrados.map((m) => (
            <div key={m.id} className="panel p-5 hover:border-dorado transition">
              
              <div className="flex items-start justify-between mb-3">
                <div>
                  <p className="text-white font-bold">{m.nombres} {m.apellidos}</p>
                  <p className="text-gray-400 text-sm">{m.email || "Sin email"}</p>
                </div>
                <span className={`insignia ${ESTADO[m.estado]?.color || "border border-zinc-500/30 bg-zinc-500/15 text-zinc-400"}`}>
                  {ESTADO[m.estado]?.label || m.estado}
                </span>
              </div>

              <div className="text-gray-400 text-sm space-y-1 mb-4">
                {m.telefono && <p>Tel. {m.telefono}</p>}
                {m.fecha_nacimiento && <p>Cumpleaños: {new Date(m.fecha_nacimiento + 'T00:00:00').toLocaleDateString("es-CO")}</p>}
                {m.como_llego && <p>Cómo llegó: {m.como_llego}</p>}
              </div>

              <div className="flex gap-2">
                <button
                  onClick={() => { setMiembroEditar(m); setMostrarForm(true); }}
                  className="flex-1 btn-fantasma btn-sm"
                >
                  Editar
                </button>
                <button
                  onClick={() => eliminarMiembro(m.id, m.nombres)}
                  className="flex-1 btn-peligro btn-sm"
                >
                  Eliminar
                </button>
              </div>

            </div>
          ))}
        </div>
      )}

      {mostrarForm && (
        <FormularioMiembro
          inicial={miembroEditar}
          onGuardar={guardarMiembro}
          onCancelar={() => { setMostrarForm(false); setMiembroEditar(null); }}
        />
      )}

    </div>
  );
}

export default Miembros;
